module.exports = __webpack_public_path__ + "img/magento-security-services@2x.250f3f2e.webp";